import React, { useEffect, useState } from "react";
import { Box, Typography, Divider, Avatar, Button } from "@mui/material";
import GitHubIcon from "@mui/icons-material/GitHub";
import FolderIcon from "@mui/icons-material/Folder";
import FolderZipIcon from "@mui/icons-material/FolderZip";
import DescriptionIcon from "@mui/icons-material/Description";
import ShieldIcon from "@mui/icons-material/Shield";
import SecurityIcon from "@mui/icons-material/Security";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import SourceIcon from "@mui/icons-material/Source";
import LoadBalancerIcon from "@mui/icons-material/Router";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import { useNavigate } from "react-router-dom";
import { ENV } from '../../config/env';

const Sidebar = () => {
  const [idToken, setidToken] = useState(null);
  const [accessToken, setaccessToken] = useState(null);
  const navigate = useNavigate();

  
  useEffect(() => {
    const idtoken = localStorage.getItem("id_token");
    const accesstoken = localStorage.getItem("access_token");
    setidToken(idtoken);
    setaccessToken(accesstoken);
    return () => {};
  }, []);

  const handleSignOut = () => {
    localStorage.removeItem("userId");
    localStorage.removeItem("id_token");
    localStorage.removeItem("access_token");
    window.location.href = ENV.LOGIN_PAGE;
  };

  return (
    <Box className="sidebar">
      {/* Branding */}
      <Box className="sidebar-branding" onClick={() => navigate("/home")}>
        <Avatar
          src="/logo.png"
          alt="logo"
          className="logo-avatar"
        />
        <Typography className="sidebar-title">
          <span className="brand-main">CodeLens</span>
        </Typography>
      </Box>

      {/* Actions */}
      <Box className="sidebar-actions">
        <Button
          variant="text"
          onClick={() => navigate("/github-connections")}
          fullWidth
          className="sidebar-btn neutral-link"
          startIcon={<GitHubIcon />}
        >
          GitHub
        </Button>

        <Button
          variant="text"
          onClick={() => navigate("/bitbucket-connections")}
          fullWidth
          className="sidebar-btn neutral-link"
          startIcon={<SourceIcon />}
        >
          Bitbucket
        </Button>


        <Button
          variant="text"
          onClick={() => navigate("/scan-repo")}
          fullWidth
          className="sidebar-btn neutral-link"
          startIcon={<FolderIcon />}
          >
          Scan Repo
        </Button>
        <Button
          variant="text"
          onClick={() => navigate("/upload-zip")}
          fullWidth
          className="sidebar-btn neutral-link"
          startIcon={<FolderZipIcon />}
          >
          Scan ZIP Code
        </Button>


        <Button
          variant="text"
          onClick={() => navigate("/report-list")}
          fullWidth
          className="sidebar-btn neutral-link"
          startIcon={<DescriptionIcon />}
        >
          Report List
        </Button>

        <Button
          variant="text"
          onClick={() => navigate("/credentials")}
          fullWidth
          className="sidebar-btn neutral-link"
          startIcon={<ManageAccountsIcon />}
        >
          Clouds Credentials
        </Button>

        <Button
          variant="text"
          onClick={() => navigate("/aws-alb-manager")}
          fullWidth
          className="sidebar-btn neutral-link"
          startIcon={<LoadBalancerIcon />}
        >
          ALB Health Preview
        </Button>

        <Button
          variant="text"
          onClick={() => navigate("/user-management")}
          fullWidth
          className="sidebar-btn neutral-link"
          startIcon={<AdminPanelSettingsIcon />}
        >
          User Management
        </Button>

        <Button
          variant="text"
          onClick={() =>
            window.open(`${ENV.COMPLAINCE_REDIRECT}?accesstoken=${accessToken}&idtoken=${idToken}`, "_blank")
          }
          fullWidth
          className="sidebar-btn neutral-link"
          startIcon={<ShieldIcon />}
        >
          Openshield
        </Button>

        <Button
          variant="text"
          onClick={() =>
            window.open(`${ENV.SECLENS_REDIRECT}?accesstoken=${accessToken}&idtoken=${idToken}`, "_blank")
          }
          fullWidth
          className="sidebar-btn neutral-link"
          startIcon={<SecurityIcon />}
        >
          SecLens
        </Button>
      </Box>

      {/* Sign Out */}
      <Box className="sidebar-signout">
        <Button
          variant="text"
          fullWidth
          className="sidebar-btn signout-btn"
          onClick={handleSignOut}
          startIcon={<ExitToAppIcon />}
        >
          Sign Out
        </Button>
      </Box>
    </Box>
  );
};

export default Sidebar;
